/* eslint-disable @typescript-eslint/no-explicit-any */
import { create } from "zustand";

type Subscriber<T = any> = (payload: T) => void;

type EventBusState = {
      subscribers: Record<string, Subscriber[]>;
      publish: <T = any>(type: string, payload?: T) => void;
      subscribe: <T = any>(type: string, handler: Subscriber<T>) => () => void;
};

export const useEventBus = create<EventBusState>((set, get) => ({
      subscribers: {},

      publish: (type, payload) => {
            const subs = get().subscribers[type] || [];
            subs.forEach((fn) => fn(payload));
      },

      subscribe: (type, handler) => {
            set((state) => {
                  const current = state.subscribers[type] || [];
                  return {
                        subscribers: {
                              ...state.subscribers,
                              [type]: [...current, handler],
                        },
                  };
            });

            // return unsubscribe function
            return () =>
                  set((state) => ({
                        subscribers: {
                              ...state.subscribers,
                              [type]: (state.subscribers[type] || []).filter(
                                    (fn) => fn !== handler
                              ),
                        },
                  }));
      },
}));
